import React, { memo } from 'react'
import { useAboutValueItem, AboutValueItemProps } from './useAboutValueItem'
import styles from './AboutValueItem.module.scss'

const AboutValueItem: React.FC<AboutValueItemProps> = (
  props: AboutValueItemProps
) => {
  const { label } = useAboutValueItem(props)

  return (
    <div className={styles['value-item']}>
      <div className={styles['value-icon']}>
        <i className='bi bi-check2'></i>
      </div>
      <span className={styles['value-label']}>{label}</span>
    </div>
  )
}

export default memo(AboutValueItem)
